import { createContext, useEffect } from "react"
import { Outlet } from "react-router-dom"
import { setLocations } from "../state/slices/locationsSlice"
import { useAppDispatch } from "../state/hooks"
import { useQueryWithEndpoint } from "../hooks/useGraphQLClient"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"

type ContextState = {}

export const LocationContext = createContext<ContextState | undefined>(undefined)

export const LocationsProvider = ({ children }: { children?: React.ReactNode }) => {
  const dispatch = useAppDispatch()
  const { data } = useQueryWithEndpoint(gqlTypes.GetLocationsDocument, {}, "primary")

  useEffect(() => {
    if (data && data.locations) {
      dispatch(setLocations(data.locations))
    }
  }, [data])

  const value = {}

  return <LocationContext.Provider value={value}>{children ? children : <Outlet />}</LocationContext.Provider>
}
